export const FETCH_SHARE = 'FETCH_SHARE';
export const FETCH_COURSE = 'FETCH_COURSE';
export const FETCH_TIMES = 'FETCH_TIMES';
export const BIND_SHARE = 'BIND_SHARE';
export const REQUEST_SHARE_BINDING = 'REQUEST_SHARE_BINDING';



// WEBPACK FOOTER //
// ./src/store/share/types.js